import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logo/logo.png";
import logoWhite from "../../assets/logo/logo-white.png";
import { UIStyleProps } from "../ui/UIComponents";

type LogoProps = {
	src?;
	width?: number;
	white?: boolean;
};

export const Logo: React.FC<UIStyleProps & LogoProps> = (props: UIStyleProps & LogoProps) => (
	<NavLink to={"/"} style={props.style || {}} className={props.className || ""}>
		<img
			src={props.white ? logoWhite : props.src || logo}
			className="logo"
			alt="logo"
			style={{ zIndex: 99999 }}
			width={props.width || 143}
			// width={168}
			// height={((process.env.REACT_APP_LOGO_HEIGHT as any) as number) || 57}
		/>
	</NavLink>
);

export default Logo;
